<template>
  <div :class="['m0-page', { 'p0-page': isChineseProduct }]">
    <template v-if="isChineseProduct">
      <section class="p0-hero">
        <img src="/static/images/product/m0-main.png" alt="" />
        <div class="p0-hero__copy">
          <h1>ANOVATOR <strong>{{ productContent.model }}</strong></h1>
          <p>{{ productContent.heroSubtitle }}</p>
        </div>
        <div class="p0-scroll"><img src="/static/images/mouse-w.png" alt="" /><span>{{ productContent.scrollLabel }}</span></div>
      </section>

      <section class="p0-functions">
        <header><p>{{ productContent.functionsKicker }}</p><h2>{{ productContent.functionsTitle }}</h2></header>
        <strong>{{ productContent.functionsCount }}</strong><span>项</span>
        <div class="p0-metrics"><span v-for="item in productContent.metrics" :key="item">{{ item }}</span></div>
      </section>

      <section class="p0-feature p0-feature--screen">
        <img src="/static/images/product/m0-jishen.png" alt="" />
        <div class="p0-feature__copy p0-feature__copy--right">
          <div><strong>{{ productContent.screenValue }}</strong><span>{{ productContent.screenUnit }}</span></div>
          <h2>{{ productContent.screenTitle }}</h2><p>{{ productContent.screenDescription }}</p>
        </div>
      </section>

      <section class="p0-feature p0-feature--base">
        <img src="/static/images/product/m0-dizuo.png" alt="" />
        <div class="p0-feature__copy p0-feature__copy--center"><h2>{{ productContent.baseTitle }}</h2><p>{{ productContent.baseDescription }}</p></div>
      </section>

      <section class="p0-seamless">
        <h2>{{ productContent.seamlessTitle }}</h2>
        <div><img src="/static/images/product/m0-jishenxq.png" alt="" /></div>
      </section>

      <section class="p0-feature p0-feature--light">
        <img src="/static/images/product/m0-jishenxq2.png" alt="" />
        <div class="p0-feature__copy p0-feature__copy--center"><h2>{{ productContent.lightTitle }}</h2><p>{{ productContent.lightDescription }}</p></div>
      </section>

      <section class="p0-feature p0-feature--sensor">
        <img src="/static/images/product/m0-dizuoxq.png" alt="" />
        <div class="p0-feature__copy p0-feature__copy--left"><h2>{{ productContent.sensorTitle }}</h2><p>{{ productContent.sensorDescription }}</p></div>
      </section>

      <section class="p0-feature p0-feature--service">
        <img src="/static/images/product/m0-tcbg.png" alt="" />
        <div class="p0-feature__copy p0-feature__copy--center">
          <h2>{{ productContent.afterSalesTitle }}</h2><p>{{ productContent.afterSalesLead }}</p>
          <a href="#contact-modal" @click.prevent="openContactModal">{{ productContent.requestDemo }}</a>
        </div>
      </section>

      <section class="p0-activation">
        <header><p>{{ productContent.cloudKicker }}</p><h2>{{ productContent.activationTitle }}</h2><span>{{ productContent.activationDescription }}</span></header>
        <img src="/static/images/product/m0-tcbg.png" alt="" />
      </section>

      <section class="p0-cloud">
        <header><p>{{ productContent.cloudKicker }}</p><h2>{{ productContent.cloudTitle }}</h2></header>
        <div class="p0-cloud__visual"><span>{{ productContent.cloudName }}</span></div>
        <p>{{ productContent.cloudDescription }}</p>
      </section>

      <section class="p0-admin">
        <header><p>{{ productContent.adminKicker }}</p><h2>{{ productContent.adminTitle }}<br />{{ productContent.adminSubtitle }}</h2></header>
        <img src="/static/images/product/m0-glht.png" alt="" />
        <div class="p0-admin__cards"><article v-for="item in productContent.adminCards" :key="item.title"><h3>{{ item.title }}</h3><p>{{ item.description }}</p></article></div>
      </section>

      <section class="p0-disclaimer"><h2>{{ productContent.disclaimerTitle }}</h2><p v-for="item in productContent.disclaimer" :key="item">{{ item }}</p></section>
    </template>

    <template v-else>
    <!-- Hero Section -->
    <section class="page-content">
      <div class="left-title-box">
        <p class="text_m0">m0</p>
        <p class="m0_title">Small Size<br />easy to buy</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-main.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-mainx2.png'" alt="M0 Main" ref="lazyImg" />
      </div>
      <div class="scroll-mouse">
        <img src="/static/images/mouse-w.png" alt="Scroll" />
        <p>Scroll Mouse</p>
      </div>
    </section>

    <!-- Functions Section -->
    <section class="page-content">
      <div class="title-box">
        <p class="text_13">7</p>
        <p class="text-11">Functions</p>
        <p class="text-12">Small body</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-function.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-functionx2.png'" alt="M0 Functions" ref="lazyImg" />
      </div>
    </section>

    <!-- Screen Section -->
    <section class="page-content">
      <div class="right-title-box">
        <p class="m0-jishen-txt">10.1<span style="font-size: 14px;">inch</span></p>
        <p class="text_21 bold-text">frameless</p>
        <p>Health data is presented graphically and<br> directly at a glance</p>
      </div>
      <div class="features-box">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-jishen.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenx2.png'" alt="M0 Screen" ref="lazyImg" />
      </div>
    </section>

    <!-- Base Section -->
    <section class="page-content">
      <div class="left-title-box m0-font-color">
        <p class="text_21 bold-text">Suspension <br>base</p>
        <p>Suspension round corner tempered glass, <br>with slim body, minimalist fashion.</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-dizuo.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-dizuox2.png'" alt="M0 Base" ref="lazyImg" />
      </div>
    </section>

    <!-- Design Section -->
    <section class="page-content" style="background-color: #FE5C00;">
      <div class="row">
        <div class="col-lg-6">
          <div class="features-box" style="top: 0;">
            <img class="feature-img mobile-adjust" src="/static/images/product/m0-jishenxq.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenxqx2.png'" alt="M0 Design" ref="lazyImg" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="left-title-box">
            <p class="text_21 bold-text">One piece design <br>Seamless</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Light Strip Section -->
    <section class="page-content">
      <div class="left-title-box m0-font-color">
        <p class="text_21 bold-text">The finishing <br>touch</p>
        <p>Family light strip Appearance level play</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-jishenxq2.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenxq2x2.png'" alt="M0 Light Strip" ref="lazyImg" />
      </div>
    </section>

    <!-- Sensor Section -->
    <section class="page-content">
      <div class="rightM-title-box m0-font-color">
        <p class="text_21 bold-text">Horizontal <br>wave sensor</p>
        <p>Accurately measure the weight per gram of the <br>
        human body and the resistivity change per ohm to <br>
        ensure the accuracy and stability of the <br>
        measurement results</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-dizuoxq.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-dizuoxqx2.png'" alt="M0 Sensor" ref="lazyImg" />
      </div>
    </section>

    <!-- Bluetooth Printing Section -->
    <section class="page-content">
      <div class="left-title-box">
        <div class="icon-list">
          <img src="/static/images/product/Bluetooth.png"/>
          <div class="divider"></div>
          <img src="/static/images/product/Print.png"/>
          <div class="divider"></div>
          <img src="/static/images/product/checkmark.png"/>
        </div>
        <p class="text_21 bold-text" style="color: #FE5C00;">Bluetooth <br>printing</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-tcbg.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-tcbgx2.png'" alt="M0 Bluetooth" ref="lazyImg" />
      </div>
    </section>

    <!-- Management System Section -->
    <section class="page-content" style="background-color: #FFFFFF;">
      <div class="m1-csbg-title" style="color: black;">
        PC background <br>management system
      </div>
      <div class="features-box">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-glht.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/n0-glhtx2.png'" alt="M0 Management" ref="lazyImg" />
      </div>
    </section>

    <!-- 3D Product View Section -->
    <div class="product-3d-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 class="section-title text-center" style="text-transform: uppercase;">M0 3D Product View</h2>
            <div class="iframe-container">
              <iframe 
                id="product-3d-iframe"
                src="/static/web/m0/m0.html" 
                width="100%" 
                height="700px" 
                frameborder="0"
                class="product-iframe"
              ></iframe>
              <p class="iframe-desc">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Technical Specifications Section -->
    <div class="tech-specs-section">
      <div class="container">
        <div class="tb-title">
          TECHNICAL SPECIFICATIONS:
        </div>
        <table class="tb technical-tb">
          <tr v-for="(spec, index) in technicalSpecs" :key="index">
            <td class="tb-key">{{ spec.left }}</td>
            <td class="tb-key">{{ spec.right }}</td>
          </tr>
        </table>
        
        <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">M0 Body Composition Analyzer</h4>
        <table class="tb product-parameters">
          <tr v-for="param in productParams" :key="param.category + param.label">
            <td v-if="param.isCategory" class="tb-col1" :rowspan="param.rowspan">{{ param.category }}</td>
            <td class="tb-col2">{{ param.label }}</td>
            <td class="tb-col3" v-html="param.value"></td>
          </tr>
        </table>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
const { siteLanguageMixin } = require('@/utils/site-language.js')
const { getM0ProductContent } = require('@/data/m0-p0-content.cjs')
const { requestContactModal } = require('@/utils/contact-modal.cjs')

export default {
  name: 'M0',
  mixins: [siteLanguageMixin],
  data() {
    return {
      technicalSpecs: [
        { left: 'User ID Login/Phone Number Login', right: 'On Screen Results' },
        { left: 'Printable Results', right: 'Handle Grips' },
        { left: 'Weight', right: 'BMI' },
        { left: 'Body Fat Percentage', right: 'Muscle Mass' },
        { left: 'Visceral Fat Area', right: 'Subcutaneous Fat Area' },
        { left: 'Protein Content', right: 'Total Body Water' },
        { left: 'Skeletal Muscle', right: 'Fat-Free Body' },
        { left: 'Bone Mass', right: 'WHR' },
        { left: 'Body Age', right: 'BMR(kcal)' },
        { left: 'Obesity Degree (%)', right: 'Desirable Weight' },
        { left: 'Weight Control', right: 'Fat Control' },
        { left: 'Muscle Control', right: 'Segmental Muscle' },
        { left: 'Segmental Body Fat', right: 'Body Type Classification' },
        { left: 'Body Posture Analysis', right: 'Total Energy Expenditure (kcal)' },
        { left: 'Calorie Consumption (kcal/hour)', right: 'Expected Fat Burning (kg)' },
        { left: 'Target Body Fat', right: 'Exercise Program Advice' },
        { left: 'Estimated Completion Period', right: 'Body Composition History' },
        { left: 'Pervious Data Comparison', right: '' }
      ],
      productParams: [
        { isCategory: true, category: 'Screen Host', rowspan: 6, label: 'Brand', value: 'Anovator' },
        { isCategory: false, label: 'Product Name', value: 'Body Composition Analyzer' },
        { isCategory: false, label: 'Model', value: 'M0' },
        { isCategory: false, label: 'Color', value: 'White' },
        { isCategory: false, label: 'Operating System', value: 'Android 11' },
        { isCategory: false, label: 'Material', value: 'Tempered Glass Led Screen + Aluminum Alloy' },
        { isCategory: true, category: 'Size & Weight', rowspan: 3, label: 'Product Size', value: 'Host: 1210mm*750mm*450mm' },
        { isCategory: false, label: 'Package Size', value: '125*755*55cm' },
        { isCategory: false, label: 'Weight', value: '25KG' },
        { isCategory: true, category: 'Display Screen', rowspan: 2, label: 'Screen Size', value: '10.1 Inch' },
        { isCategory: false, label: 'Screen Type', value: '800*1280 IPS HD Touch' },
        { isCategory: true, category: 'Technical Parameters', rowspan: 4, label: 'Measurement methods', value: '8-point contact electrodes, multi-frequency bioelectrical impedance analysis technology' },
        { isCategory: false, label: 'Frequency', value: '20,100 kHz' },
        { isCategory: false, label: 'Electric Current', value: '<280uA' },
        { isCategory: false, label: 'Power consumption', value: '15W' },
        { isCategory: true, category: 'Function parameter', rowspan: 8, label: 'Report', value: 'Phone/Paper Print Report/Web' },
        { isCategory: false, label: 'Voltage', value: 'Input: AC 220V，50/60Hz <br />Output：DC 12V,7A' },
        { isCategory: false, label: 'Transmission Port', value: 'USB2.0/Bluetooth/Wired/Wireless' },
        { isCategory: false, label: 'Height Range', value: '80-200cm' },
        { isCategory: false, label: 'Weight Range', value: '0-200kg' },
        { isCategory: false, label: 'Age Range', value: '3-99 years old' },
        { isCategory: false, label: 'Operating Environment', value: 'Internet Connection Required <br />Temperature: 10-40℃, Humidity: 30%-75% <br />Do not place the device by the window to avoid direct sunlight.<br />Do not shine direct light on the device screen.<br />Do not hit the device hard.' },
        { isCategory: false, label: 'Save the environment', value: 'Temperature: -20~70℃, Humidity: ≤95%' }
      ]
    }
  },
  computed: {
    isChineseProduct() {
      return this.currentLanguage === 'ZH'
    },
    productContent() {
      return getM0ProductContent(this.currentLanguage)
    }
  },
  watch: {
    currentLanguage() {
      document.title = `${this.productContent.model} - Anovator`
      this.$nextTick(this.initLazyLoading)
    }
  },
  mounted() {
    document.title = `${this.productContent.model} - Anovator`;
    
    // 初始化图片懒加载
    this.initLazyLoading();
    
    // 3D iframe responsive handling
    let resizeTimeout;
    const handle3DResize = () => {
      const iframe = document.getElementById('product-3d-iframe');
      if (iframe) {
        const src = iframe.src;
        iframe.src = '';
        setTimeout(() => {
          iframe.src = src;
        }, 100);
      }
    };
    
    const debouncedResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handle3DResize, 500);
    };
    
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('orientationchange', function() {
      setTimeout(debouncedResize, 500);
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('orientationchange', this.debouncedResize);
  },
  methods: {
    openContactModal(event) {
      requestContactModal(event?.currentTarget)
    },
    initLazyLoading() {
      // 获取所有带有data-src属性的图片
      const lazyImages = document.querySelectorAll('img[data-src]');
      
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const dataSrc = img.getAttribute('data-src');
              if (dataSrc) {
                img.src = dataSrc;
                img.removeAttribute('data-src');
                observer.unobserve(img);
              }
            }
          });
        });
        
        lazyImages.forEach(img => imageObserver.observe(img));
      } else {
        // 降级处理：直接加载所有图片
        lazyImages.forEach(img => {
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc) {
            img.src = dataSrc;
            img.removeAttribute('data-src');
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.m0-page {
  background-color: #FFFFFF;
}

.page-content {
  position: relative;
  width: 100vw;
}

.features-box {
  width: 100%;
  height: 100%;
}

.feature-img {
  display: block;
  width: 100vw;
  height: calc(100vh - 90px);
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.feature-img2 {
  display: block;
  width: 100vw;
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.title-box {
  position: absolute;
  width: 100%;
  top: 9vh;
  text-align: center;
  z-index: 10;
}

.left-title-box {
  position: absolute;
  left: 20%;
  bottom: 45%;
  z-index: 10;
}

.right-title-box {
  position: absolute;
  right: 25%;
  top: 30%;
  z-index: 10;
}

.rightM-title-box {
  position: absolute;
  right: 10%;
  bottom: 40%;
  z-index: 10;
  padding-left: 20px;
}

.bold-text {
  font-weight: 600;
  font-size: 45px !important;
  line-height: 55px !important;
  text-transform: uppercase;
}

.text_m0 {
  overflow-wrap: break-word;
  color: rgba(254, 92, 0, 1);
  font-size: 50px;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 55px;
  text-transform: uppercase;
  margin-bottom: 0;
}

.m0_title {
  color: rgba(0, 0, 0, 1);
  font-size: 35px;
  text-transform: uppercase;
  font-weight: 700;
  font-family: MiSans-Bold;
  text-align: left;
}

.text_13 {
  overflow-wrap: break-word;
  color: rgba(254, 92, 0, 1);
  font-size: 7vw;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.text-11 {
  position: relative;
  color: rgba(90, 59, 59, 1);
  text-transform: uppercase;
  font-family: MiSans-Regular;
  font-size: 0.8vw;
  margin-bottom: 0;
  top: -6vh;
}

.text-12 {
  font-size: 2vw;
  text-transform: uppercase;
  color: #000000;
  font-family: MiSans-Bold;
}

.text_21 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 3.33vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  white-space: normal;
  line-height: 4.45vw;
}

.m0-jishen-txt {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 6.66vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.icon-list {
  display: flex;
  margin-bottom: 20px;
}

.icon-list img {
  width: 80px;
}

.divider {
  position: relative;
  width: 55px;
  height: 3px;
  margin: 5px 10px;
  background-color: #DCDCDC;
  top: 35px;
}

.m1-csbg-title {
  position: relative;
  width: 100%;
  text-align: center;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 2.5vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  white-space: normal;
  line-height: 3.5vw;
  z-index: 10;
  top: 28vh;
}

.scroll-mouse {
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.scroll-mouse img {
  width: 30px;
  height: 30px;
}

.scroll-mouse p {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 10px;
}

.product-3d-section {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin-top: 150px;
  margin-bottom: 0;
}

.section-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-weight: bold;
}

.iframe-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 20px;
  margin: 0 auto;
}

.product-iframe {
  border: none;
  border-radius: 10px;
  min-height: 300px;
}

.iframe-desc {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}

.tech-specs-section {
  background-color: #000000;
  padding-bottom: 10px;
}

.tb-title {
  width: 100%;
  height: 300px;
  padding-top: 230px;
  font-size: 30px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 35px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #FFFFFF;
}

.tb th, .tb td {
  border: 1px solid #3F3F3F;
  padding: 15px;
}

.tb tr {
  height: 40px;
}

.tb-key {
  width: 50%;
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  width: 20%;
  font-weight: 600;
  text-align: center;
}

.tb-col2 {
  width: 30%;
  text-align: left;
}

.tb-col3 {
  width: 50%;
  text-align: left;
}

.p0-page {
  color: #000;
  background: #f1f1f1;
  font-family: MiSans-Regular, sans-serif;
}

.p0-page h1,
.p0-page h2,
.p0-page h3,
.p0-page p {
  margin: 0;
}

.p0-hero,
.p0-feature {
  position: relative;
  height: 710px;
  overflow: hidden;
}

.p0-hero {
  height: 770px;
  background: #fff;
}

.p0-hero > img,
.p0-feature > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.p0-hero__copy {
  position: absolute;
  top: 92px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.p0-hero__copy h1 { font: 700 24px/1.25 MiSans-Bold, sans-serif; }
.p0-hero__copy h1 strong { color: #ef0a6a; }
.p0-hero__copy p { margin-top: 8px; color: rgba(0, 0, 0, .6); font-size: 16px; }
.p0-scroll { position: absolute; bottom: 18px; left: 50%; display: grid; justify-items: center; gap: 4px; transform: translateX(-50%); font-size: 12px; }
.p0-scroll img { width: 22px; filter: invert(1); }

.p0-functions {
  position: relative;
  height: 710px;
  overflow: hidden;
  text-align: center;
  background: linear-gradient(0deg, #fff, #fff4ea);
}

.p0-functions header,
.p0-cloud header,
.p0-admin header,
.p0-activation header { padding-top: 140px; text-align: center; }
.p0-functions header p,
.p0-cloud header p,
.p0-admin header p { margin-bottom: 12px; color: #5a3b3b; font-size: 16px; }
.p0-functions h2 { font: 700 28px/1.3 MiSans-Bold, sans-serif; }
.p0-functions > strong { display: inline-block; margin-top: 50px; color: #fe5c00; font: 700 96px/1 MiSans-Bold, sans-serif; }
.p0-functions > span { margin-left: 6px; color: #5a3b3b; font-size: 12px; }
.p0-metrics { position: relative; width: 720px; height: 250px; margin: -40px auto 0; }
.p0-metrics span { position: absolute; display: grid; width: 118px; height: 118px; place-items: center; border-radius: 50%; color: #5a3b3b; font-size: 12px; background: rgba(255,255,255,.86); box-shadow: 0 18px 45px rgba(254,92,0,.12); }
.p0-metrics span:nth-child(1) { left: 80px; top: 0; }.p0-metrics span:nth-child(2) { right: 80px; top: 0; }.p0-metrics span:nth-child(3) { left: 0; top: 112px; }.p0-metrics span:nth-child(4) { left: 180px; top: 122px; }.p0-metrics span:nth-child(5) { right: 180px; top: 122px; }.p0-metrics span:nth-child(6) { right: 0; top: 112px; }.p0-metrics span:nth-child(7) { left: 301px; top: 154px; }

.p0-feature__copy { position: absolute; z-index: 1; width: min(570px, 42vw); }
.p0-feature__copy h2 { font: 700 40px/1.25 MiSans-Bold, sans-serif; }
.p0-feature__copy p { margin-top: 14px; font-size: 16px; line-height: 1.6; }
.p0-feature__copy--right { top: 185px; left: 56%; }
.p0-feature__copy--left { top: 175px; left: 10%; }
.p0-feature__copy--center { top: 70px; left: 50%; transform: translateX(-50%); text-align: center; }
.p0-feature__copy--right strong { color: #fe5c00; font: 700 96px/1 MiSans-Bold, sans-serif; }
.p0-feature__copy--right span { font-size: 16px; }
.p0-feature--base,
.p0-feature--light,
.p0-feature--sensor { background: linear-gradient(0deg, #fff, #fff4ea); }
.p0-feature--service .p0-feature__copy { color: #fff; }
.p0-feature--service a { display: inline-flex; height: 30px; margin-top: 24px; padding: 0 20px; align-items: center; border-radius: 15px; color: #fff; background: #ef0a6a; text-decoration: none; }

.p0-seamless { height: 734px; padding: 72px; text-align: center; background: #f5f5f7; }
.p0-seamless h2 { margin-bottom: 34px; font: 700 40px/1.25 MiSans-Bold, sans-serif; }
.p0-seamless div { height: 444px; overflow: hidden; border-radius: 40px; background: #fff; }
.p0-seamless img { width: 100%; height: 100%; object-fit: cover; }

.p0-activation,
.p0-cloud,
.p0-admin { position: relative; overflow: hidden; text-align: center; background: #f5f5f7; }
.p0-activation { min-height: 860px; padding-bottom: 80px; background: #fff; }
.p0-activation header { width: min(960px, calc(100% - 32px)); margin: 0 auto 46px; }
.p0-activation h2,
.p0-cloud h2,
.p0-admin h2 { font: 700 40px/1.3 MiSans-Bold, sans-serif; }
.p0-activation header > span { display: block; max-width: 820px; margin: 22px auto 0; color: rgba(0,0,0,.6); font-size: 16px; line-height: 1.7; }
.p0-activation > img { width: min(820px, 80vw); height: 460px; object-fit: cover; object-position: center; }
.p0-cloud { min-height: 920px; }
.p0-cloud__visual { display: grid; width: 566px; height: 566px; margin: 55px auto 24px; place-items: center; border-radius: 50%; color: #ef0a6a; font: 700 40px/1 MiSans-Bold, sans-serif; background: radial-gradient(circle, #fff 0 18%, rgba(239,10,106,.2) 19%, transparent 53%), repeating-radial-gradient(circle, transparent 0 90px, rgba(0,0,0,.08) 91px 92px); }
.p0-cloud > p { max-width: 989px; margin: 0 auto 60px; color: rgba(0,0,0,.4); font-size: 12px; }
.p0-admin { min-height: 1120px; background: #fff; }
.p0-admin > img { width: min(760px, 72vw); margin-top: 70px; }
.p0-admin__cards { display: grid; width: 782px; max-width: calc(100% - 32px); margin: 18px auto 70px; grid-template-columns: repeat(2, 1fr); gap: 50px; text-align: left; }
.p0-admin__cards h3 { padding-bottom: 15px; border-bottom: 1px solid rgba(0,0,0,.25); font-size: 20px; }
.p0-admin__cards p { margin-top: 18px; color: rgba(0,0,0,.6); font-size: 17px; line-height: 1.55; }
.p0-disclaimer { padding: 50px max(72px, calc((100vw - 1296px) / 2)); color: rgba(0,0,0,.6); background: #f1f1f1; }
.p0-disclaimer h2 { margin-bottom: 10px; font-size: 12px; }
.p0-disclaimer p { font-size: 12px; line-height: 1.55; }

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .p0-hero { height: 576px; }
  .p0-hero__copy { top: 74px; width: calc(100% - 32px); }
  .p0-hero__copy h1 { font-size: 18px; }
  .p0-hero__copy p { font-size: 12px; }
  .p0-hero > img { object-position: 58% center; }
  .p0-functions { height: 474px; }
  .p0-functions header { padding-top: 58px; }
  .p0-functions header p { font-size: 11px; }
  .p0-functions h2 { font-size: 18px; }
  .p0-functions > strong { margin-top: 38px; font-size: 64px; }
  .p0-metrics { width: 390px; max-width: 100%; height: 195px; margin-top: -20px; transform: scale(.72); transform-origin: center top; }
  .p0-feature { height: 480px; }
  .p0-feature__copy { width: calc(100% - 32px); text-align: center; }
  .p0-feature__copy h2 { font-size: 24px; }
  .p0-feature__copy p { font-size: 12px; line-height: 1.5; }
  .p0-feature__copy--right,
  .p0-feature__copy--left,
  .p0-feature__copy--center { top: 48px; left: 16px; transform: none; }
  .p0-feature__copy--right strong { font-size: 56px; }
  .p0-feature--screen > img { object-position: 38% center; }
  .p0-feature--sensor .p0-feature__copy { top: 330px; }
  .p0-feature--service .p0-feature__copy { top: 46px; }
  .p0-seamless { height: 410px; padding: 42px 16px; }
  .p0-seamless h2 { margin-bottom: 24px; font-size: 24px; }
  .p0-seamless div { height: 270px; border-radius: 16px; }
  .p0-activation { min-height: 650px; }
  .p0-activation header,
  .p0-cloud header,
  .p0-admin header { padding-top: 64px; }
  .p0-activation h2,
  .p0-cloud h2,
  .p0-admin h2 { font-size: 24px; }
  .p0-activation header > span { font-size: 12px; }
  .p0-activation > img { width: calc(100% - 32px); height: 300px; }
  .p0-cloud { min-height: 620px; }
  .p0-cloud__visual { width: 330px; height: 330px; margin-top: 35px; font-size: 24px; }
  .p0-cloud > p { width: calc(100% - 32px); font-size: 10px; }
  .p0-admin { min-height: 850px; }
  .p0-admin > img { width: calc(100% - 32px); margin-top: 45px; }
  .p0-admin__cards { grid-template-columns: 1fr; gap: 24px; }
  .p0-admin__cards h3 { font-size: 16px; }
  .p0-admin__cards p { font-size: 13px; }
  .p0-disclaimer { padding: 32px 16px; }
  .features-box{
    margin-top: 0;
  }
  .left-title-box {
    left: 10%;
    bottom: 35%;
  }
  .title-box{
    top: 30vh;
  }
  .mobile-adjust{
    height: 100vh;
  }
  .right-title-box {
    right: 10%;
    top: 25%;
  }
  .feature-img2{
    height: auto;
  }
  
  .rightM-title-box {
    right: 5%;
    bottom: 30%;
    padding-left: 10px;
  }
  
  .text_m0 {
    font-size: 35px;
  }
  
  .m0_title {
    font-size: 25px;
  }
  
  .text_13 {
    font-size: 50px;
  }
  
  .text-11 {
    font-size: 12px;
    top: 0;
  }
  
  .text-12 {
    font-size: 20px;
  }
  
  .text_21 {
    font-size: 5vw;
    line-height: 6vw;
  }
  
  .m0-jishen-txt {
    font-size: 8vw;
  }
  
  .bold-text {
    font-size: 30px !important;
    line-height: 35px !important;
  }
  
  .icon-list img {
    width: 60px;
  }
  
  .divider {
    width: 40px;
    top: 25px;
  }
  
  .m1-csbg-title {
    font-size: 4vw;
    line-height: 5vw;
    top: 10vh;
  }
  
  .product-3d-section {
    padding: 40px 0;
    margin-top: 20vh;
  }
  
  .iframe-container {
    padding: 15px;
    margin: 0 10px;
  }
  
  .product-iframe {
    height: 400px !important;
    min-height: 300px !important;
  }
  
  .tb-title {
    height: 200px;
    padding-top: 150px;
    font-size: 20px;
  }
  
  .tb th, .tb td {
    padding: 10px;
    font-size: 12px;
  }
  
  .tb-key {
    background-size: 16px;
    padding-right: 20px;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  .product-3d-section {
    padding: 40px 0;
  }
  
  .product-iframe {
    height: 350px !important;
    min-height: 250px !important;
  }
}

/* Landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .product-3d-section {
    padding: 20px 0;
  }
  
  .product-iframe {
    height: 300px !important;
    min-height: 200px !important;
  }
  
  .iframe-container {
    margin: 0 20px;
  }
}

/* 4K and large screen optimization */
@media (min-width: 1920px) {
  .feature-img, .feature-img2 {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .features-box {
    width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
}
</style>
